export const CRYO_FIXED_ACCESSORIES = [
  { id: 158, label: 'ACC-9035 - Exempt Human Specimen Label' },
  { id: 170, label: 'ACC-9040 - Do Not X-RAY label' },
  { id: 286, label: 'ACC-9160 - SEAL, 12", SERIALIZED, BLUE' },
] as const;

export const CRYO_RACK_OPTIONS = [
  { value: 200, label: 'ACC-8905 - Rack, High Volume Shipper' },
  { value: 209, label: 'ACC-9122 - Blood Cassette Rack' },
  { value: 1379, label: 'SET-1000 - SAFEPAK SOFT SYSTEM 1800' },
];

/** Auto-added when High Volume Shipper rack (200) is selected. */
export const CRYO_HIGH_VOLUME_RACK_ID = 200;
export const CRYO_SAFEPAK_900 = {
  id: 272,
  label: 'ACC-9140 - Safepak® 900 (formerly Safepak® XL)',
} as const;

export const CRYO_CURRENCY_OPTIONS = [
  { label: '(USD) US Dollar', value: 'USD' },
  { label: '(AED) UAE Dirham', value: 'AED' },
  { label: '(AFN) Afghani', value: 'AFN' },
  { label: '(ALL) Lek', value: 'ALL' },
  { label: '(AMD) Armenian Dram', value: 'AMD' },
  { label: '(ANG) Netherlands Antillean Guilder', value: 'ANG' },
  { label: '(AOA) Kwanza', value: 'AOA' },
  { label: '(ARS) Argentine Peso', value: 'ARS' },
  { label: '(AUD) Australian Dollar', value: 'AUD' },
  { label: '(AWG) Aruban Florin', value: 'AWG' },
  { label: '(AZN) Azerbaijanian Manat', value: 'AZN' },
  { label: '(BAM) Convertible Mark', value: 'BAM' },
  { label: '(BBD) Barbados Dollar', value: 'BBD' },
  { label: '(BDT) Taka', value: 'BDT' },
  { label: '(BGN) Bulgarian Lev', value: 'BGN' },
  { label: '(BHD) Bahraini Dinar', value: 'BHD' },
  { label: '(BIF) Burundi Franc', value: 'BIF' },
  { label: '(BMD) Bermudian Dollar', value: 'BMD' },
  { label: '(BND) Brunei Dollar', value: 'BND' },
  { label: '(BOB) Boliviano', value: 'BOB' },
  { label: '(BRL) Brazilian Real', value: 'BRL' },
  { label: '(BSD) Bahamian Dollar', value: 'BSD' },
  { label: '(BTN) Ngultrum', value: 'BTN' },
  { label: '(BWP) Pula', value: 'BWP' },
  { label: '(BYN) Belarussian Ruble', value: 'BYN' },
  { label: '(BZD) Belize Dollar', value: 'BZD' },
  { label: '(CAD) Canadian Dollar', value: 'CAD' },
  { label: '(CDF) Congolese Franc', value: 'CDF' },
  { label: '(CHF) Swiss Franc', value: 'CHF' },
  { label: '(CLP) Chilean Peso', value: 'CLP' },
  { label: '(CNY) Yuan Renminbi', value: 'CNY' },
  { label: '(COP) Colombian Peso', value: 'COP' },
  { label: '(CRC) Costa Rican Colon', value: 'CRC' },
  { label: '(CUP) Cuban Peso', value: 'CUP' },
  { label: '(CVE) Cabo Verde Escudo', value: 'CVE' },
  { label: '(CZK) Czech Koruna', value: 'CZK' },
  { label: '(DJF) Djibouti Franc', value: 'DJF' },
  { label: '(DKK) Danish Krone', value: 'DKK' },
  { label: '(DOP) Dominican Peso', value: 'DOP' },
  { label: '(DZD) Algerian Dinar', value: 'DZD' },
  { label: '(EGP) Egyptian Pound', value: 'EGP' },
  { label: '(ERN) Nakfa', value: 'ERN' },
  { label: '(ETB) Ethiopian Birr', value: 'ETB' },
  { label: '(EUR) Euro', value: 'EUR' },
  { label: '(FJD) Fiji Dollar', value: 'FJD' },
  { label: '(FKP) Falkland Islands Pound', value: 'FKP' },
  { label: '(GBP) Pound Sterling', value: 'GBP' },
  { label: '(GEL) Lari', value: 'GEL' },
  { label: '(GHS) Ghana Cedi', value: 'GHS' },
  { label: '(GIP) Gibraltar Pound', value: 'GIP' },
  { label: '(GMD) Dalasi', value: 'GMD' },
  { label: '(GNF) Guinea Franc', value: 'GNF' },
  { label: '(GTQ) Quetzal', value: 'GTQ' },
  { label: '(GYD) Guyana Dollar', value: 'GYD' },
  { label: '(HKD) Hong Kong Dollar', value: 'HKD' },
  { label: '(HNL) Lempira', value: 'HNL' },
  { label: '(HRK) Kuna', value: 'HRK' },
  { label: '(HTG) Gourde', value: 'HTG' },
  { label: '(HUF) Forint', value: 'HUF' },
  { label: '(IDR) Rupiah', value: 'IDR' },
  { label: '(ILS) New Israeli Sheqel', value: 'ILS' },
  { label: '(INR) Indian Rupee', value: 'INR' },
  { label: '(IQD) Iraqi Dinar', value: 'IQD' },
  { label: '(IRR) Iranian Rial', value: 'IRR' },
  { label: '(ISK) Iceland Krona', value: 'ISK' },
  { label: '(JMD) Jamaican Dollar', value: 'JMD' },
  { label: '(JOD) Jordanian Dinar', value: 'JOD' },
  { label: '(JPY) Yen', value: 'JPY' },
  { label: '(KES) Kenyan Shilling', value: 'KES' },
  { label: '(KGS) Som', value: 'KGS' },
  { label: '(KHR) Riel', value: 'KHR' },
  { label: '(KMF) Comoro Franc', value: 'KMF' },
  { label: '(KPW) North Korean Won', value: 'KPW' },
  { label: '(KRW) Won', value: 'KRW' },
  { label: '(KWD) Kuwaiti Dinar', value: 'KWD' },
  { label: '(KYD) Cayman Islands Dollar', value: 'KYD' },
  { label: '(KZT) Tenge', value: 'KZT' },
  { label: '(LAK) Kip', value: 'LAK' },
  { label: '(LBP) Lebanese Pound', value: 'LBP' },
  { label: '(LKR) Sri Lanka Rupee', value: 'LKR' },
  { label: '(LRD) Liberian Dollar', value: 'LRD' },
  { label: '(LSL) Loti', value: 'LSL' },
  { label: '(LYD) Libyan Dinar', value: 'LYD' },
  { label: '(MAD) Moroccan Dirham', value: 'MAD' },
  { label: '(MDL) Moldovan Leu', value: 'MDL' },
  { label: '(MGA) Malagasy Ariary', value: 'MGA' },
  { label: '(MKD) Denar', value: 'MKD' },
  { label: '(MMK) Kyat', value: 'MMK' },
  { label: '(MNT) Tugrik', value: 'MNT' },
  { label: '(MOP) Pataca', value: 'MOP' },
  { label: '(MRU) Ouguiya', value: 'MRU' },
  { label: '(MUR) Mauritius Rupee', value: 'MUR' },
  { label: '(MVR) Rufiyaa', value: 'MVR' },
  { label: '(MWK) Kwacha', value: 'MWK' },
  { label: '(MXN) Mexican Peso', value: 'MXN' },
  { label: '(MYR) Malaysian Ringgit', value: 'MYR' },
  { label: '(MZN) Mozambique Metical', value: 'MZN' },
  { label: '(NAD) Namibia Dollar', value: 'NAD' },
  { label: '(NGN) Naira', value: 'NGN' },
  { label: '(NIO) Cordoba Oro', value: 'NIO' },
  { label: '(NOK) Norwegian Krone', value: 'NOK' },
  { label: '(NPR) Nepalese Rupee', value: 'NPR' },
  { label: '(NZD) New Zealand Dollar', value: 'NZD' },
  { label: '(OMR) Rial Omani', value: 'OMR' },
  { label: '(PAB) Balboa', value: 'PAB' },
  { label: '(PEN) Nuevo Sol', value: 'PEN' },
  { label: '(PGK) Kina', value: 'PGK' },
  { label: '(PHP) Philippine Peso', value: 'PHP' },
  { label: '(PKR) Pakistan Rupee', value: 'PKR' },
  { label: '(PLN) Zloty', value: 'PLN' },
  { label: '(PYG) Guarani', value: 'PYG' },
  { label: '(QAR) Qatari Rial', value: 'QAR' },
  { label: '(RON) Romanian Leu', value: 'RON' },
  { label: '(RSD) Serbian Dinar', value: 'RSD' },
  { label: '(RUB) Russian Ruble', value: 'RUB' },
  { label: '(RWF) Rwanda Franc', value: 'RWF' },
  { label: '(SAR) Saudi Riyal', value: 'SAR' },
  { label: '(SBD) Solomon Islands Dollar', value: 'SBD' },
  { label: '(SCR) Seychelles Rupee', value: 'SCR' },
  { label: '(SDG) Sudanese Pound', value: 'SDG' },
  { label: '(SEK) Swedish Krona', value: 'SEK' },
  { label: '(SGD) Singapore Dollar', value: 'SGD' },
  { label: '(SHP) Saint Helena Pound', value: 'SHP' },
  { label: '(SLL) Leone', value: 'SLL' },
  { label: '(SOS) Somali Shilling', value: 'SOS' },
  { label: '(SRD) Surinam Dollar', value: 'SRD' },
  { label: '(SSP) South Sudanese Pound', value: 'SSP' },
  { label: '(STN) Dobra', value: 'STN' },
  { label: '(SVC) El Salvador Colon', value: 'SVC' },
  { label: '(SYP) Syrian Pound', value: 'SYP' },
  { label: '(SZL) Lilangeni', value: 'SZL' },
  { label: '(THB) Baht', value: 'THB' },
  { label: '(TJS) Somoni', value: 'TJS' },
  { label: '(TMT) Turkmenistan New Manat', value: 'TMT' },
  { label: '(TND) Tunisian Dinar', value: 'TND' },
  { label: "(TOP) Pa'anga", value: 'TOP' },
  { label: '(TRY) Turkish Lira', value: 'TRY' },
  { label: '(TTD) Trinidad and Tobago Dollar', value: 'TTD' },
  { label: '(TWD) New Taiwan Dollar', value: 'TWD' },
  { label: '(TZS) Tanzanian Shilling', value: 'TZS' },
  { label: '(UAH) Hryvnia', value: 'UAH' },
  { label: '(UGX) Uganda Shilling', value: 'UGX' },
  { label: '(UYU) Peso Uruguayo', value: 'UYU' },
  { label: '(UZS) Uzbekistan Sum', value: 'UZS' },
  { label: '(VEF) Bolivar', value: 'VEF' },
  { label: '(VND) Dong', value: 'VND' },
  { label: '(VUV) Vatu', value: 'VUV' },
  { label: '(WST) Tala', value: 'WST' },
  { label: '(XAF) CFA Franc BEAC', value: 'XAF' },
  { label: '(XCD) East Caribbean Dollar', value: 'XCD' },
  { label: '(XOF) CFA Franc BCEAO', value: 'XOF' },
  { label: '(XPF) CFP Franc', value: 'XPF' },
  { label: '(YER) Yemeni Rial', value: 'YER' },
  { label: '(ZAR) Rand', value: 'ZAR' },
  { label: '(ZMW) Zambian Kwacha', value: 'ZMW' },
  { label: '(ZWL) Zimbabwe Dollar', value: 'ZWL' },
];
